import React from 'react';

const Footer = ({ children }) => <div className='panel__footer'>{children}</div>;

export default Footer;
